import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
import styles from './styles';

const FakeTextInfo = ({ className, height }) => {
  return (
    <div className={`fake-text-info ${className}`}>
      <ContentLoader height={height} width="100%" {...fakeSettings}>
        <rect x="0" y="0" rx="1" ry="1" width="100%" height={height} />
      </ContentLoader>
      <style jsx>{styles}</style>
    </div>
  );
};
export default FakeTextInfo;
